/*LIBRARY*/
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

/*COMPONENT*/
import TextFieldGroup, {
  SelectField,
} from "../../Components/common_input/TextFieldGroup";

/*REDUX*/
import {
  edit_text_profile,
  edit_text_profile_2,
} from "../../App/actions/authActions";

/*PICTURE*/

/*FUNCTION*/
import dict from "../../Data/dict.json";

/*DATA*/
import countries from "../../Data/countries.json";
import EditWaNumber from "../../Components/user/EditWaNumber";
import EditEmail from "../../Components/user/EditEmail";

/*CONST*/

const EditProfile = () => {
  const dispatch = useDispatch();

  // Destructure props (from Redux store via hooks)
  const auth = useSelector((state) => state.auth);
  const { user, loading, itemLoading } = auth;

  const [state, setState] = useState({
    userId: "",
    bio: "",
    fullname: "",
    dateofbrithday: "",
    industry: "",
    country: "",
  });

  const { bio, fullname, dateofbrithday, industry, country, userId } = state;

  // Replacement for getDerivedStateFromProps
  useEffect(() => {
    if (
      user &&
      Object.keys(user).length !== 0 &&
      user.constructor === Object &&
      user._id !== userId
    ) {
      setState((prevState) => ({
        ...prevState,
        userId: user._id,
        bio: user.bio,
        fullname: user.full_name,
        dateofbrithday: user.birthday,
        industry: user.industry,
        country: user.country,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // --- CHANGED: Handle Change with Slice Logic ---
  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    // If the field is fullname, slice it to 50 chars immediately
    if (name === "fullname" && value.length > 50) {
      newValue = value.slice(0, 50);
    }

    setState({ ...state, [name]: newValue });
  };

  // --- LOGIC: Calculate character counts ---
  const nameLength = fullname ? fullname.length : 0;
  const isNameInvalid = nameLength > 50;
  const isNameFull = nameLength >= 50;

  // --- LOGIC: Calculate Age & Validate ---
  let userAge = null;
  let isUnderAge = false;

  if (dateofbrithday) {
    const today = new Date(Date.now()); // Accessing Date.now() as requested
    const birthDate = new Date(dateofbrithday);

    // Calculate difference in years
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    // Adjust if birthday hasn't happened yet this year
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    userAge = age;
    // Check constraint: Min 10 years old
    if (userAge < 10) {
      isUnderAge = true;
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    // Extra safety check
    if (isUnderAge) return;

    const body = {
      bio,
    };
    dispatch(edit_text_profile(body));

    const body_2 = {
      full_name: fullname,
      birthday: dateofbrithday,
      industry,
      country: country,
    };
    dispatch(edit_text_profile_2(body_2));
  };

  const language = localStorage?.language ? localStorage?.language : "ina";

  const countries_list = countries.map((countryItem) => ({
    name: countryItem.name,
    title: countryItem.name,
  }));

  // Disable button if name is invalid OR user is under 10
  const isSubmitDisabled = isNameInvalid || isUnderAge;

  let button = (
    <button
      type="submit"
      className="save_button"
      onClick={handleSubmit}
      data-mapid="clickSave"
      disabled={isSubmitDisabled}
      style={{
        opacity: isSubmitDisabled ? 0.5 : 1,
        cursor: isSubmitDisabled ? "not-allowed" : "pointer",
      }}
    >
      {dict["Save"][language]}
    </button>
  );

  if (loading && itemLoading === "edit_text_profile") {
    button = (
      <div className="button background_black">
        {dict["Saving"][language]}...
      </div>
    );
  }

  const industry_list = [
    {
      value: "Information Technology and Services",
      title: dict["Information Technology and Services"][language],
    },
    // ... (rest of your industry list remains the same)
    {
      value: "Fishery and Marine",
      title: dict["Fishery and Marine"][language],
    },
  ];

  const itemContent = (
    <div>
      <h1 className="title_modal_new">Edit User</h1>
      <div className="edit_profile_row">
        <div style={{ width: "100%" }}>
          <TextFieldGroup
            placeholder={dict["Full name"][language]}
            name="fullname"
            id="fullname"
            value={fullname}
            onChange={handleChange}
          />
          <div
            style={{
              textAlign: "right",
              color: isNameFull ? "red" : "green",
              fontSize: "12px",
              fontWeight: "bold",
              marginTop: "2px",
              marginBottom: "10px",
            }}
          >
            ({nameLength}/50)
          </div>
        </div>

        <TextFieldGroup
          placeholder="Bio"
          name="bio"
          id="bio"
          value={bio}
          onChange={handleChange}
        />

        {/* DATE OF BIRTH SECTION */}
        <div style={{ width: "100%" }}>
          <TextFieldGroup
            placeholder={dict["date of birth"][language]}
            type="date"
            name="dateofbrithday"
            id="dateofbrithday"
            value={dateofbrithday}
            onChange={handleChange}
          />
          {/* Age Info / Validation Display */}
          {dateofbrithday && (
            <div
              style={{
                textAlign: "right",
                // Requested color is black.
                // Note: You might want 'red' for errors, but strictly following 'color is black' requirement:
                color: "black",
                fontSize: "12px",
                fontWeight: "bold",
                marginTop: "2px",
                marginBottom: "10px",
              }}
            >
              Age: {userAge} Years Old{" "}
              {isUnderAge ? "(Min. 10 Years Required)" : ""}
            </div>
          )}
        </div>

        <SelectField
          Title={dict["Where the organization operates"][language]}
          list_array={countries_list}
          id="country"
          name="country"
          value={country}
          onChange={handleChange}
          placeholder={`${dict["Choose country"][language]}`}
        />

        <SelectField
          list_array={industry_list}
          name="industry"
          id="industry"
          value={industry}
          onChange={handleChange}
          placeholder={dict["industry"][language]}
        />

        <EditWaNumber placeholder={dict["Whatsapp Number"][language]} />
        <EditEmail placeholder={"Email"} />

        <div style={{ width: "120px" }}>{button}</div>
      </div>
    </div>
  );

  return <div className="main_container">{itemContent}</div>;
};

export default EditProfile;
